import { Button, Form, Row, Space, theme } from "antd";
import FormItem from "../../form/form-item";
import { useCallback, useEffect } from "react";
import { useGetCounselingsQuery, useGetEmployeesQuery } from "../../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../../util/with-save-notification";

import { DeleteOutlined } from "@ant-design/icons";
import { AdvancedForm, useAdvancedFormContext } from "../../form/advanced-form";

const { useCreateCounselingWithSaveNotificationMutation, useUpdateCounselingWithSaveNotificationMutation, useDeleteCounselingWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;


const AddDateButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button onClick={onClick} disabled={advancedFormContext.readOnly}>
      Weiteren Beratungstermin hinzufügen
    </Button>
  )
}

const DeleteButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button icon={<DeleteOutlined />} onClick={onClick} disabled={advancedFormContext.readOnly} />
  )
}

function CustomerCounseling({ customerId }) {
  const [form] = Form.useForm();
  const { data } = useGetCounselingsQuery({ f: JSON.stringify({ "customer.id": { c: "EQ", v: customerId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  const [ createCounseling, { isLoading: isCreatingRelative } ] = useCreateCounselingWithSaveNotificationMutation();
  const [ updateCounseling, { isLoading: isUpdatingRelative } ] = useUpdateCounselingWithSaveNotificationMutation();
  const [ deleteCounseling, { isLoading: isDeletingRelative } ] = useDeleteCounselingWithSaveNotificationMutation();
  //const relatives = useMemo(() => data.items || [], [data])

  const isLoading = isCreatingRelative || isUpdatingRelative || isDeletingRelative;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const onFinish = useCallback(async (values: any) => {
    console.log('On finish', values);
    const promisesCreateUpdate = values.items.map(i => {
      console.log("Creating / updating relative", i);
      if(i.id) {
        return updateCounseling(i);
      } else {
        return createCounseling(i);
      }
    })

    const promisesDelete = data.items.filter(i => !values.items.find(i2 => i.id === i2.id)).map(i => deleteCounseling(i));
    
    await Promise.all([...promisesCreateUpdate, ...promisesDelete]);
  }, [createCounseling, updateCounseling, deleteCounseling, data]);

  return (<AdvancedForm form={form} name="relatives" style={formStyle} onFinish={onFinish} originalValues={data} isLoading={isLoading}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>{
        fields.map((field, index) => { return <>
          <Row><h3>Beratungstermin { index + 1 } <DeleteButton onClick={() => remove(index)} /></h3></Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="date" label="Datum" type="date" typeData={{ picker: "month" }}/>
            <FormItem field={field} fieldName="employeeId" label="Mitarbeiter" type="ref" typeData={{ query: useGetEmployeesQuery, getId: employee => employee.id, render: employee => `${employee.id} - ${employee.firstName} ${employee.lastName}`}} />
            <FormItem field={field} fieldName="tookPlace" label="hat stattgefunden" type="check" />
          </Row>
        </>})}
        <div style={{ textAlign: 'right', marginBottom: '24px' }}>
          <Space size="small">
            <AddDateButton onClick={() => add({ customerId })} />
          </Space>
        </div>
        </>
      }
    </Form.List> 
    </AdvancedForm>)
}

export default CustomerCounseling